import { Action } from '../../../common/actions/core/action';

export class OpenStudentBlockedAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/blocked/blocked.action.ts